import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useAutoRenew } from '../../services/hooks'
import { Checkbox, WingBlank } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'
import { ClosableToast } from './ClosableToast'

const AutoRenewCheckbox = ({ checked, setChecked, jump, setJump }) => {
  const { profiles } = useSelector((state) => ({
    profiles: state.data.profile,
  }))
  const [bind, setBind] = useState(false)
  const [show, setShow] = useState(false)
  const { show: showAutoRenewPopup } = ClosableToast({ content: '您在申请时可勾选会员自动更新。' })

  const { loading } = useAutoRenew({
    onSuccess: (data) => {
      if (!profiles.isMainlandAddress) {
        return
      }
      setBind(data.bind)
      setShow(true)
      if (data.bind) {
        setChecked(true)
        setJump(false)
      } else {
        showAutoRenewPopup()
        if (checked) {
          setJump(true)
        }
      }
    },
  })

  const handleChange = (checked) => {
    setChecked(checked)
    setJump(checked)
  }

  if (loading) return null

  return (
    show && (
      <WingBlank>
        <Checkbox.AgreeItem
          style={{ marginLeft: '0' }}
          checked={checked}
          disabled={bind}
          onChange={(e) => handleChange(e.target.checked)}
        >
          <FormattedMessage id="auto-renew-member-agreement" />
          <br />
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={
              'https://pro-cms.padi.com/sites/default/files/documents/training-hub/728DTSC%20Automatic%20Renewal%20Details.pdf'
            }
          >
            自动更新协议
          </a>
          <br />
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={
              'https://pro-cms.padi.com/sites/default/files/documents/training-hub/728DT%20Automatic%20Renewal%20Details_0.pdf'
            }
          >
            Automatic Renewal Agreement
          </a>
        </Checkbox.AgreeItem>
      </WingBlank>
    )
  )
}

export default AutoRenewCheckbox
